/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Photo_AddInputs */

const en_editor_photo_add = /** @type {(inputs: Editor_Photo_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add photo`)
};

const de_editor_photo_add = /** @type {(inputs: Editor_Photo_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add photo" |
*
* @param {Editor_Photo_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_photo_add = /** @type {((inputs?: Editor_Photo_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Photo_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_photo_add(inputs)
	return en_editor_photo_add(inputs)
});